import { render, staticRenderFns } from "./CalcFormCard.vue?vue&type=template&id=9b94f806&scoped=true&"
import script from "./CalcFormCard.vue?vue&type=script&lang=js&"
export * from "./CalcFormCard.vue?vue&type=script&lang=js&"
import style0 from "./CalcFormCard.vue?vue&type=style&index=0&id=9b94f806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b94f806",
  null
  
)

export default component.exports